/*********************************************************
 * LAB FLIPBOOK - FULL JS
 * Desktop : Horizontal flip (rotationY)
 * Mobile  : Active issue reader only
 *********************************************************/

function dbg(...args) {
  console.log("[FLIPBOOK]", ...args);
}

/* =========================
   GHOST-CLICK SUPPRESSION
========================= */
window.__suppressBookToggleUntil = 0;

function suppressBookToggle(ms = 650) {
  window.__suppressBookToggleUntil = Date.now() + ms;
}

function isBookToggleSuppressed() {
  return Date.now() < (window.__suppressBookToggleUntil || 0);
}

/* =========================
   MAIN INIT
========================= */
document.addEventListener("DOMContentLoaded", function () {
  dbg("DOMContentLoaded (main)");

  const menuItems = document.querySelectorAll(".lab-menu li");
  const issueBooks = document.querySelectorAll(".issue-book");
  const labBook = document.getElementById("labBook");
  const savedIssue = sessionStorage.getItem("openIssue");

  dbg(
    "Found labBook:",
    !!labBook,
    "| menuItems:",
    menuItems.length,
    "| issueBooks:",
    issueBooks.length
  );

  function isMobileFlipbook() {
    return window.matchMedia("(max-width: 930px)").matches;
  }

  function resetPages() {
    if (!labBook) return;

    getActiveIssueBook()
      .querySelectorAll(".page")
      .forEach((page) => {
        page.classList.remove("left");
        page.classList.add("right");

        if (typeof TweenLite !== "undefined") {
          TweenLite.set(page, { rotationX: 0, rotationY: 0, zIndex: 1 });
        }
      });

    window.pageLocation = {};
    window.zi = 0;
  }

  function closeBook() {
    if (!labBook) return;

    labBook.classList.add("is-closed");
    labBook.classList.remove("end-page-visible");
    resetPages();

    window.bookOpened = false;
  }

  function getActiveIssueBook() {
    if (!labBook) return document;
    return labBook.querySelector(".issue-book.active") || labBook;
  }

  function clearMobileStack() {
    if (!labBook) return;

    labBook.querySelectorAll("#mobileStack").forEach((stack) => stack.remove());
    labBook.classList.remove("mobile-stack-active");
    labBook.__mobileFlipbook = null;

    labBook
      .querySelectorAll(".is-hidden-mobile")
      .forEach((el) => el.classList.remove("is-hidden-mobile"));
  }

  function rebuildMobileStack() {
    if (!labBook || !isMobileFlipbook()) return;

    const activeBook = getActiveIssueBook();
    if (!activeBook || !activeBook.classList.contains("issue-book")) {
      dbg("MOBILE: No active issue book found");
      return;
    }

    const activeIssue = activeBook.dataset.issue;
    const mobileIssueCovers = {
      "issue-one":
        "https://cdn.shopify.com/s/files/1/0972/1152/files/SKULLS_ISSUE_PAGE_1_COVER.webp?v=1769601896",
      "issue-two":
        "https://cdn.shopify.com/s/files/1/0972/1152/files/LAB_ISSUE_TWO_NEWSLETTER_FIRST_IMAGE.jpg?v=1784098069",
    };
    const mobileIssueEndPages = {
      "issue-one":
        "https://cdn.shopify.com/s/files/1/0972/1152/files/LAB_ISSUE_ONE_BACK_PAGE.png?v=1769748987",
    };

    clearMobileStack();

    labBook.classList.remove("is-closed", "end-page-visible");
    labBook.classList.add("mobile-stack-active");
    window.bookOpened = true;

    const pageBg = activeBook.querySelector(".pageBg");
    if (!pageBg) {
      dbg("MOBILE: pageBg not found in active issue:", activeBook.dataset.issue);
      return;
    }

    const stack = document.createElement("div");
    stack.id = "mobileStack";
    stack.className = "mobile-stack";
    stack.style.display = "block";
    stack.style.width = "100%";

    const addedSrcs = new Set();

    function addImageFromSrc(src, alt) {
      if (!src || addedSrcs.has(src)) return;

      const img = document.createElement("img");
      img.src = src;
      img.alt = alt || "Page";
      img.loading = "eager";
      img.className = "mobile-page-image mobile-image-hidden";
      img.dataset.issue = activeIssue;
      img.dataset.pageIndex = stack.querySelectorAll("img").length;
      img.style.display = "none";
      img.style.opacity = "0";
      img.style.visibility = "hidden";
      img.style.position = "absolute";
      img.style.objectFit = "cover";
      img.style.objectPosition = "center center";

      stack.appendChild(img);
      addedSrcs.add(src);
    }

    function addImage(sourceImg, alt) {
      if (!sourceImg?.src) return;
      addImageFromSrc(sourceImg.src, sourceImg.alt || alt);
    }

    addImageFromSrc(mobileIssueCovers[activeIssue], "Cover Page");

    const staticImg = activeBook.querySelector(
      ".static-left-page img, .static-left img, .staticPage img, [class*='static'] img"
    );
    addImage(staticImg, "Page 2");

    let pages = Array.from(activeBook.querySelectorAll(".pageWrapper .page"));
    if (pages.length === 0) {
      pages = Array.from(activeBook.querySelectorAll(".page"));
    }
    if (pages.length === 0) {
      pages = Array.from(labBook.querySelectorAll(".page")).filter(
        (page) => page.closest(".issue-book") === activeBook
      );
    }

    pages.sort((a, b) => {
      const na = parseInt((a.id || "").replace(/[^\d]/g, ""), 10);
      const nb = parseInt((b.id || "").replace(/[^\d]/g, ""), 10);
      return (Number.isNaN(na) ? 0 : na) - (Number.isNaN(nb) ? 0 : nb);
    });

    pages.forEach((page, pageIndex) => {
      const front =
        page.querySelector(".pageFace.front img") ||
        page.querySelector(".front img, [class*='front'] img") ||
        page.querySelectorAll("img")[0];

      const back =
        page.querySelector(".pageFace.back img") ||
        page.querySelector(".back img, [class*='back'] img") ||
        page.querySelectorAll("img")[1];

      addImage(front, `${page.id || `page${pageIndex}`} front`);

      if (back?.src && back.src !== front?.src) {
        addImage(back, `${page.id || `page${pageIndex}`} back`);
      }
    });

    if (stack.querySelectorAll("img").length <= 1) {
      dbg("MOBILE: Page selectors found too few images, using active issue image fallback");

      activeBook.querySelectorAll("img").forEach((img, imgIndex) => {
        addImage(img, `Page ${imgIndex + 1}`);
      });
    }

    addImageFromSrc(mobileIssueEndPages[activeIssue], "End Page");

    const totalImages = stack.querySelectorAll("img").length;
    dbg("MOBILE STACK COMPLETE:", totalImages, "images for", activeIssue);

    pageBg.appendChild(stack);

    activeBook.querySelector(".static-left-page")?.classList.add("is-hidden-mobile");
    activeBook.querySelector(".pageWrapper")?.classList.add("is-hidden-mobile");

    const allImages = Array.from(stack.querySelectorAll("img"));
    let currentImageIndex = -1;
    let isMobileAnimating = false;

    function getMobilePageHeight() {
      const stackWidth = stack.clientWidth || pageBg.clientWidth || 300;
      return Math.round(stackWidth * 1.48);
    }

    function isIssueTwoCoverImage(img) {
      return img?.dataset.issue === "issue-two" && img.dataset.pageIndex === "0";
    }

    function getMobileImageHeight(img) {
      const stackWidth = stack.clientWidth || pageBg.clientWidth || 300;

      if (isIssueTwoCoverImage(img)) {
        return Math.round(stackWidth * 1.38);
      }

      return getMobilePageHeight();
    }

    function applyConsistentMobileImageSize(img) {
      const pageHeight = getMobileImageHeight(img);
      const isIssueTwoCover = isIssueTwoCoverImage(img);

      img.style.setProperty("width", "100%", "important");
      img.style.setProperty("height", pageHeight + "px", "important");
      img.style.setProperty("max-height", "none", "important");
      img.style.setProperty("object-fit", isIssueTwoCover ? "fill" : "cover", "important");
      img.style.setProperty("object-position", "center center", "important");
      img.style.setProperty("margin-left", "0", "important");
      img.style.setProperty("margin-right", "0", "important");
      img.style.setProperty("background", "#fff", "important");
    }

    function lockMobileStackHeight(activeImg = allImages[currentImageIndex]) {
      const pageHeight = getMobileImageHeight(activeImg);
      stack.style.height = pageHeight + "px";
      stack.style.minHeight = pageHeight + "px";
      stack.style.overflow = "visible";
      stack.style.position = "relative";
    }

    allImages.forEach((img) => {
      img.loading = "eager";
      img.style.cursor = "pointer";
      applyConsistentMobileImageSize(img);

      if (!img.complete) {
        const preloadImg = new Image();
        preloadImg.src = img.src;
      }
    });

    function showImage(index, skipLog = false, animate = true) {
      if (isMobileAnimating || index < 0 || index >= allImages.length) return;
      if (index === currentImageIndex && !skipLog) return;

      const previousIndex = currentImageIndex;
      const previousImg = previousIndex >= 0 ? allImages[previousIndex] : null;
      const nextImg = allImages[index];
      const direction = index > previousIndex ? 1 : -1;

      allImages.forEach((img, i) => {
        const isActive = i === index;

        img.classList.toggle("mobile-image-hidden", !isActive);
        img.classList.toggle("mobile-image-active", isActive);
        img.style.setProperty("display", isActive ? "block" : "none", "important");
        img.style.setProperty("visibility", isActive ? "visible" : "hidden", "important");
        img.style.setProperty("opacity", isActive ? "1" : "0", "important");
        img.style.setProperty("position", isActive ? "relative" : "absolute", "important");
        img.style.setProperty("top", isActive ? "0" : "-9999px", "important");
        img.style.setProperty("left", "0", "important");
        applyConsistentMobileImageSize(img);
        img.style.setProperty("transform", "none", "important");
        img.style.setProperty("z-index", isActive ? "2" : "0", "important");
      });

      lockMobileStackHeight(nextImg);
      stack.style.overflow = animate && previousImg ? "hidden" : "visible";
      currentImageIndex = index;

      if (animate && previousImg && previousImg !== nextImg) {
        isMobileAnimating = true;

        const pageHeight = getMobileImageHeight(nextImg);
        stack.style.height = pageHeight + "px";
        stack.style.perspective = "900px";

        previousImg.style.setProperty("display", "block", "important");
        previousImg.style.setProperty("visibility", "visible", "important");
        previousImg.style.setProperty("opacity", "1", "important");
        previousImg.style.setProperty("position", "absolute", "important");
        previousImg.style.setProperty("top", "0", "important");
        previousImg.style.setProperty("left", "0", "important");
        previousImg.style.setProperty("z-index", "3", "important");
        previousImg.style.setProperty("transform-origin", direction > 0 ? "left center" : "right center", "important");

        nextImg.style.setProperty("position", "absolute", "important");
        nextImg.style.setProperty("top", "0", "important");
        nextImg.style.setProperty("left", "0", "important");
        nextImg.style.setProperty("z-index", "2", "important");
        nextImg.style.setProperty("transform-origin", direction > 0 ? "right center" : "left center", "important");

        previousImg.style.transition = "none";
        nextImg.style.transition = "none";
        previousImg.style.transform = "rotateY(0deg)";
        nextImg.style.transform = `rotateY(${direction > 0 ? 8 : -8}deg)`;
        nextImg.style.opacity = "0.72";

        requestAnimationFrame(() => {
          previousImg.style.transition =
            "transform 420ms ease-in, opacity 420ms ease-in";
          nextImg.style.transition =
            "transform 420ms ease-out, opacity 420ms ease-out";

          previousImg.style.transform = `rotateY(${direction > 0 ? -78 : 78}deg)`;
          previousImg.style.opacity = "0";
          nextImg.style.transform = "rotateY(0deg)";
          nextImg.style.opacity = "1";
        });

        window.setTimeout(() => {
          previousImg.classList.add("mobile-image-hidden");
          previousImg.classList.remove("mobile-image-active");
          previousImg.style.setProperty("display", "none", "important");
          previousImg.style.setProperty("visibility", "hidden", "important");
          previousImg.style.setProperty("opacity", "0", "important");
          previousImg.style.setProperty("position", "absolute", "important");
          previousImg.style.setProperty("top", "-9999px", "important");
          previousImg.style.transition = "";
          previousImg.style.transform = "none";

          nextImg.style.setProperty("position", "relative", "important");
          nextImg.style.setProperty("z-index", "2", "important");
          nextImg.style.transition = "";
          nextImg.style.transform = "none";
          nextImg.style.opacity = "1";

          lockMobileStackHeight(nextImg);
          isMobileAnimating = false;
        }, 460);
      }

      if (!skipLog) {
        dbg(`MOBILE: Showing image ${index + 1} of ${allImages.length}`);
      }
    }

    function navigateToNeighbor(direction) {
      const newIndex = Math.max(
        0,
        Math.min(currentImageIndex + direction, allImages.length - 1)
      );

      if (newIndex !== currentImageIndex) {
        showImage(newIndex);
      } else {
        dbg("MOBILE: Navigation ignored at edge", {
          currentImageIndex,
          direction,
          totalImages: allImages.length,
        });
      }
    }

    showImage(0, true, false);
    lockMobileStackHeight(allImages[0]);

    if (labBook.__mobileResizeHandler) {
      window.removeEventListener("resize", labBook.__mobileResizeHandler);
    }

    labBook.__mobileResizeHandler = () => {
      allImages.forEach(applyConsistentMobileImageSize);
      lockMobileStackHeight(allImages[currentImageIndex]);
    };

    window.addEventListener("resize", labBook.__mobileResizeHandler);

    labBook.__mobileFlipbook = {
      activeIssue,
      totalImages: allImages.length,
      getCurrentIndex: () => currentImageIndex,
      showImage,
      navigateToNeighbor,
    };

    let lastClickTime = 0;
    stack.addEventListener("click", (e) => {
      if (e.target.closest("button")) return;

      const clickedImg = e.target.closest("img");
      if (!clickedImg?.classList.contains("mobile-image-active")) return;

      const now = Date.now();
      if (now - lastClickTime < 300) return;
      lastClickTime = now;

      e.stopPropagation();
      e.preventDefault();

      const rect = clickedImg.getBoundingClientRect();
      const direction = (e.clientX - rect.left) / rect.width < 0.5 ? -1 : 1;
      navigateToNeighbor(direction);
    });

    dbg("MOBILE: Navigation ready", {
      activeIssue,
      totalImages: allImages.length,
    });
  }

  function setActiveIssue(issue) {
    if (!labBook || !issue) return;

    issueBooks.forEach((book) => {
      book.classList.toggle("active", book.dataset.issue === issue);
    });

    labBook.classList.remove(
      "issue-one-book",
      "issue-two-book",
      "end-page-visible",
      "mobile-stack-active"
    );

    if (issue === "issue-one" || issue === "issue-two") {
      labBook.classList.add(issue + "-book");
    }

    clearMobileStack();
    resetPages();

    if (isMobileFlipbook()) {
      rebuildMobileStack();
    } else {
      closeBook();
    }
  }

  if (savedIssue && labBook) {
    setActiveIssue(savedIssue);
  }

  if (!window.__labMobileNavBound) {
    window.__labMobileNavBound = true;
    window.__labMobileNavLastTap = 0;

    const mobileNavHandler = (e) => {
      const navButton = e.target.closest(
        "#nextPageClosed, #nextPageOpen, #prevPageOpen"
      );

      if (!navButton || !isMobileFlipbook()) return;

      const activeLabBook = document.getElementById("labBook");
      const mobileFlipbook = activeLabBook?.__mobileFlipbook;

      if (!mobileFlipbook) return;

      const now = Date.now();
      if (now - window.__labMobileNavLastTap < 250) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        return;
      }

      window.__labMobileNavLastTap = now;

      const direction = navButton.id === "prevPageOpen" ? -1 : 1;

      suppressBookToggle(700);
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      dbg("MOBILE: Document button nav", {
        button: navButton.id,
        direction,
        activeIssue: mobileFlipbook.activeIssue,
        currentImageIndex: mobileFlipbook.getCurrentIndex(),
        totalImages: mobileFlipbook.totalImages,
      });

      mobileFlipbook.navigateToNeighbor(direction);
    };

    document.addEventListener("pointerdown", mobileNavHandler, {
      capture: true,
      passive: false,
    });
    document.addEventListener("click", mobileNavHandler, {
      capture: true,
      passive: false,
    });
  }

  menuItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      const issue = item.dataset.issue;

      if (e.target.closest("a")) return;

      menuItems.forEach((i) => i.classList.remove("active"));
      item.classList.add("active");

      if (issue === "issue-one" || issue === "issue-two") {
        e.preventDefault();

        if (!labBook) {
          sessionStorage.setItem("openIssue", issue);
          window.location.href = "/";
          return;
        }

        setActiveIssue(issue);
        return;
      }

      if (issue && labBook) {
        e.preventDefault();

        issueBooks.forEach((book) => {
          book.classList.toggle("active", book.dataset.issue === issue);
        });

        closeBook();
      }
    });
  });

  /* =========================
     HAMBURGER MENU
  ========================= */
  const sidebar = document.getElementById("labSidebar");
  const hamburger = document.getElementById("labHamburger");
  const overlay = document.getElementById("labOverlay");

  if (sidebar && hamburger && overlay) {
    hamburger.addEventListener("click", () => {
      sidebar.classList.toggle("is-open");
      overlay.classList.toggle("is-active");
      document.body.style.overflow = sidebar.classList.contains("is-open")
        ? "hidden"
        : "";
    });

    overlay.addEventListener("click", () => {
      sidebar.classList.remove("is-open");
      overlay.classList.remove("is-active");
      document.body.style.overflow = "";
    });
  }

  /* =========================
     FLIP BOOK LOGIC
  ========================= */
  if (!labBook || typeof TweenLite === "undefined" || typeof TweenMax === "undefined") {
    dbg("Flipbook init skipped:", {
      labBook: !!labBook,
      TweenLite: typeof TweenLite !== "undefined",
      TweenMax: typeof TweenMax !== "undefined",
    });
  } else {
    let isMobile = isMobileFlipbook();
    const ROT_PROP = "rotationY";

    dbg(
      "Mode:",
      isMobile ? "MOBILE active issue reader" : "DESKTOP rotationY flip",
      "| viewport width:",
      window.innerWidth
    );

    window.bookOpened = false;
    window.pageLocation = {};
    window.zi = 0;

    labBook.classList.add("is-closed");

    TweenLite.set(".pageBg", { xPercent: -50, yPercent: -50 });
    TweenLite.set(".pageWrapper", { left: "50%", perspective: 1000 });
    TweenLite.set(".page", { transformStyle: "preserve-3d" });
    TweenLite.set(".back", { rotationY: -180 });
    TweenLite.set([".back", ".front"], { backfaceVisibility: "hidden" });

    if (isMobile) {
      dbg("MOBILE: enabling active issue reader");
      rebuildMobileStack();
      return;
    }

    function openBook() {
      dbg("openBook()");
      labBook.classList.remove("is-closed");
      window.bookOpened = true;
      void labBook.offsetHeight;
    }

    function closeBookLocal() {
      dbg("closeBookLocal()");
      closeBook();
    }

    function getPageNumber(el) {
      const m = (el?.id || "").match(/page(\d+)/i);
      return m ? parseInt(m[1], 10) : 9999;
    }

    function getRightPages() {
      const activeBook = getActiveIssueBook();
      const pages = Array.from(activeBook.querySelectorAll(".page.right"));
      pages.sort((a, b) => getPageNumber(a) - getPageNumber(b));
      return pages;
    }

    function getLeftPages() {
      const activeBook = getActiveIssueBook();
      const pages = Array.from(activeBook.querySelectorAll(".page.left"));
      pages.sort((a, b) => getPageNumber(a) - getPageNumber(b));
      return pages;
    }

    let flippingPageId = null;

    function flipPage(pageEl, toLeft) {
      if (!pageEl) {
        dbg("flipPage(): no page element");
        return;
      }

      if (flippingPageId === pageEl.id) {
        dbg("flipPage() already flipping:", pageEl.id, "skipping");
        return;
      }

      flippingPageId = pageEl.id;

      setTimeout(() => {
        flippingPageId = null;
      }, 1100);

      window.zi++;

      const originToLeft = "-1px top";
      const originToRight = "left top";

      dbg("flipPage()", {
        page: pageEl.id,
        toLeft,
        ROT_PROP,
        origin: toLeft ? originToLeft : originToRight,
        zi: window.zi,
      });

      if (typeof TweenMax !== "undefined") {
        TweenMax.killTweensOf(pageEl);
      }

      pageEl.classList.toggle("right", !toLeft);
      pageEl.classList.toggle("left", toLeft);
      window.pageLocation[pageEl.id] = toLeft ? "left" : "right";

      void pageEl.offsetHeight;

      TweenMax.to(pageEl, 1, {
        [ROT_PROP]: toLeft ? -180 : 0,
        transformOrigin: toLeft ? originToLeft : originToRight,
        zIndex: window.zi,
        immediateRender: false,
        onComplete: function () {
          if (toLeft) {
            const remainingRightPages = getRightPages();

            if (remainingRightPages.length === 0) {
              dbg("Last page flipped, showing end page");
              labBook.classList.add("end-page-visible");
            }
          }
        },
      });
    }

    labBook.addEventListener("click", function (e) {
      if (isBookToggleSuppressed()) {
        dbg("labBook click suppressed (recent nav tap)");
        return;
      }

      if (e.target.closest(".book-nav-open, .book-next-closed, button")) return;
      if (e.target.closest(".page")) return;

      dbg("labBook background click toggle. bookOpened:", window.bookOpened);

      if (window.bookOpened) closeBookLocal();
      else openBook();
    });

    labBook.querySelectorAll(".page").forEach((page) => {
      page.addEventListener("click", function (e) {
        if (!window.bookOpened) {
          dbg("Page click ignored (book not open):", this.id);
          return;
        }

        if (isBookToggleSuppressed()) {
          dbg("Page click suppressed (recent nav tap):", this.id);
          e.stopPropagation();
          return;
        }

        e.stopPropagation();

        const isRight = this.classList.contains("right");

        dbg("Page click:", this.id, "| isRight:", isRight);
        flipPage(this, isRight);
      });
    });

    const nextBtnClosed = document.getElementById("nextPageClosed");
    const nextBtnOpen = document.getElementById("nextPageOpen");
    const prevBtnOpen = document.getElementById("prevPageOpen");

    function bindTap(el, name, handler) {
      if (!el) {
        dbg("Missing button:", name);
        return;
      }

      let lastClick = 0;
      let isHandling = false;

      const wrapped = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        if (isHandling) {
          dbg(`DESKTOP: Already handling ${name}, ignoring`);
          return;
        }

        const now = Date.now();
        if (now - lastClick < 300) {
          dbg(`DESKTOP: Ignoring rapid click on ${name}`);
          return;
        }

        lastClick = now;
        isHandling = true;

        suppressBookToggle(700);

        dbg("Button tap:", name, "| bookOpened:", window.bookOpened);

        setTimeout(() => {
          isHandling = false;
        }, 100);

        handler();
      };

      el.addEventListener("pointerup", wrapped, { passive: false });

      dbg("Bound button:", name);
    }

    let isNextActionRunning = false;

    function nextAction() {
      if (isNextActionRunning) {
        dbg("nextAction() already running, skipping");
        return;
      }

      isNextActionRunning = true;

      setTimeout(() => {
        isNextActionRunning = false;
      }, 1100);

      if (!window.bookOpened) {
        openBook();
        isNextActionRunning = false;
        return;
      }

      const rightPages = getRightPages();
      dbg(
        "nextAction() rightPages found:",
        rightPages.length,
        rightPages.map((p) => p.id)
      );

      const nextPage = rightPages[0] || null;
      dbg("nextAction() nextPage:", nextPage?.id || null);

      if (nextPage) {
        flipPage(nextPage, true);
      } else {
        dbg("nextAction() no nextPage found");
        isNextActionRunning = false;
      }
    }

    function prevAction() {
      if (!window.bookOpened) {
        dbg("prevAction() ignored (book not open)");
        return;
      }

      const leftPages = getLeftPages();
      const prevPage = leftPages.length ? leftPages[leftPages.length - 1] : null;

      dbg("prevAction() prevPage:", prevPage?.id || null);

      if (!prevPage) {
        dbg("prevAction(): no left pages -> closing book");
        closeBookLocal();
        return;
      }

      flipPage(prevPage, false);
    }

    bindTap(nextBtnClosed, "nextPageClosed", nextAction);
    bindTap(nextBtnOpen, "nextPageOpen", nextAction);
    bindTap(prevBtnOpen, "prevPageOpen", prevAction);
  }

  /* =========================
     SKELETON LOADER
  ========================= */
  const skeleton = document.getElementById("labBookSkeleton");
  if (skeleton && labBook) {
    requestAnimationFrame(() => {
      labBook.classList.add("is-ready");
      skeleton.style.display = "none";
      dbg("Skeleton hidden. is-ready set.");
    });
  }
});

/* =========================
   ACTIVE MENU HIGHLIGHT BY URL
========================= */
document.addEventListener("DOMContentLoaded", () => {
  dbg("DOMContentLoaded (active menu highlight)");

  const menuItems = document.querySelectorAll(".lab-menu li");
  const path = window.location.pathname;

  menuItems.forEach((li) => li.classList.remove("active"));

  if (path === "/" || path === "") {
    const savedIssue = sessionStorage.getItem("openIssue");
    const activeIssue = savedIssue || "issue-two";

    document
      .querySelector(`.lab-menu li[data-issue="${activeIssue}"]`)
      ?.classList.add("active");

    sessionStorage.removeItem("openIssue");
    return;
  }

  menuItems.forEach((li) => {
    const link = li.querySelector("a");
    if (!link) return;

    const href = link.getAttribute("href");
    if (href && path.startsWith(href)) {
      li.classList.add("active");
    }
  });
});

/* =========================
   FOOTAGE ITEM LOGIC
========================= */
document.addEventListener("DOMContentLoaded", function () {
  dbg("DOMContentLoaded (footage logic)");

  const footageItem = document.querySelector('.lab-menu li[data-issue="footage"]');

  if (!footageItem) {
    dbg("Footage item not found");
    return;
  }

  footageItem.addEventListener("click", function (e) {
    if (e.target.closest("a")) return;
    e.preventDefault();

    dbg("Footage menu clicked");

    if (!document.getElementById("labBook")) {
      sessionStorage.setItem("openFootage", "1");
      window.location.href = "/";
      return;
    }

    openFootage();
  });

  function openFootage() {
    const issueBooks = document.querySelectorAll(".issue-book");
    const labBook = document.getElementById("labBook");
    if (!labBook) return;

    document
      .querySelectorAll(".lab-menu li")
      .forEach((li) => li.classList.remove("active"));

    footageItem.classList.add("active");

    issueBooks.forEach((book) => {
      book.classList.toggle("active", book.dataset.issue === "footage");
    });

    labBook
      .querySelectorAll("#mobileStack")
      .forEach((stack) => stack.remove());

    labBook.classList.add("is-closed");
    labBook.classList.remove(
      "mobile-stack-active",
      "issue-one-book",
      "issue-two-book",
      "end-page-visible"
    );

    window.bookOpened = false;
    window.pageLocation = {};
    window.zi = 0;

    dbg("openFootage(): book reset closed");
  }

  if (
    document.getElementById("labBook") &&
    sessionStorage.getItem("openFootage") === "1"
  ) {
    sessionStorage.removeItem("openFootage");
    dbg("Auto-open footage after redirect");
    openFootage();
  }
});

/* =========================
   FOOTAGE VIDEO SWITCH
========================= */
document.addEventListener("click", (e) => {
  if (e.target.matches(".footage-thumbs video")) {
    const src = e.target.dataset.src;
    const mainVideo = document.getElementById("mainVideo");
    if (!mainVideo) return;

    dbg("Footage thumb video clicked -> src:", src);

    mainVideo.pause();
    mainVideo.src = src;
    mainVideo.load();
    mainVideo.play();
  }

  if (e.target.matches(".footage-thumbs img")) {
    const videoId = e.target.dataset.video;
    const mainVideo = document.getElementById("mainVideo");
    if (!mainVideo) return;

    dbg("Footage thumb img clicked -> videoId:", videoId);

    mainVideo.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  }
});
